import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { Reveal, MaskText } from "@/components/Reveal";
import { Seo } from "@/components/Seo";
import { ArrowUpRight } from "lucide-react";

const HERO = "https://images.unsplash.com/photo-1509563268479-0f004cf3f58b?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export default function Atletas() {
  const { t, tr } = useLang();
  const [fighters, setFighters] = useState([]);
  const [hero, setHero] = useState("");
  useEffect(() => { api.get("/fighters").then((r) => setFighters(r.data)); api.get("/site").then((r) => setHero(r.data.hero?.athletes || "")); }, [tr]);

  return (
    <div data-testid="athletes-page">
      <Seo
        title={tr("Atletas VORNA | Peleadores Patrocinados en Ecuador", "VORNA Athletes | Sponsored Fighters in Ecuador")}
        description={tr("Conoce a los atletas patrocinados por VORNA: peleadores ecuatorianos de MMA y deportes de combate, sus records y disciplinas.", "Meet the VORNA sponsored athletes: Ecuadorian MMA and combat-sports fighters, their records and disciplines.")}
        path="/atletas"
      />
      <section className="relative h-[70vh] overflow-hidden flex items-end">
        <img src={hero || HERO} alt={tr("Atletas de VORNA", "VORNA athletes")} className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-black/30" />
        <div className="relative mx-auto max-w-[1600px] w-full px-5 lg:px-10 pb-16">
          <p className="text-xs tracking-[0.35em] text-vorna-accent uppercase mb-4">{tr("El Roster", "The Roster")}</p>
          <h1 className="font-display uppercase tracking-tighter text-[13vw] lg:text-[9vw] leading-[0.8]"><MaskText lines={tr(["Nuestros", "Atletas"], ["Our", "Athletes"])} /></h1>
        </div>
      </section>

      <section className="mx-auto max-w-[1600px] px-5 lg:px-10 py-16 lg:py-24">
        <Reveal><p className="max-w-2xl text-lg text-white/60 leading-relaxed mb-14">
          {tr("Desde los campamentos en Ecuador hasta la competencia profesional, estos son los atletas que viven el deporte y representan a VORNA.",
              "From training camps in Ecuador to professional competition, these are the athletes who live the sport and represent VORNA.")}
        </p></Reveal>

        <div className="space-y-4">
          {fighters.map((f, i) => (
            <Reveal key={f.id} delay={0.03}>
              <Link to={`/atletas/${f.id}`} data-testid={`athlete-row-${f.id}`} className="group grid lg:grid-cols-[380px_1fr] gap-6 lg:gap-12 items-stretch border-b border-white/10 pb-4">
                <div className="relative aspect-[4/3] lg:aspect-[4/5] overflow-hidden bg-vorna-elevated">
                  <img src={f.image} alt={f.name} className="h-full w-full object-cover object-top grayscale group-hover:grayscale-0 transition-all duration-700 group-hover:scale-105" />
                  <span className="absolute top-4 left-4 font-display text-6xl text-white/20">0{i + 1}</span>
                </div>
                <div className="flex flex-col justify-center py-4">
                  <div className="flex items-start justify-between">
                    <div>
                      <h2 className="font-display uppercase tracking-tighter text-4xl lg:text-6xl leading-[0.85] group-hover:text-vorna-accent transition-colors">{f.name}</h2>
                      <p className="mt-2 font-heading uppercase text-vorna-accent tracking-wide text-lg">"{f.nickname}"</p>
                    </div>
                    <ArrowUpRight className="h-8 w-8 text-white/30 group-hover:text-vorna-accent group-hover:translate-x-1 group-hover:-translate-y-1 transition-all shrink-0" />
                  </div>
                  <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-2xl">
                    <Stat label={t("record")} value={f.record} />
                    <Stat label={t("weight_class")} value={f.weight_class} />
                    <Stat label={t("disciplineL")} value={f.discipline} />
                    <Stat label={t("city")} value={f.city} />
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}

function Stat({ label, value }) {
  if (!value) return null;
  return (
    <div>
      <p className="text-[10px] tracking-widest text-white/30 uppercase">{label}</p>
      <p className="text-sm font-semibold mt-1">{value}</p>
    </div>
  );
}
